import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { uuid } from '@masar/common/utils';

interface AttachmentValue {
    name?: string;
}

@Component({
    selector: 'app-attachment-input',
    templateUrl: './attachment-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AttachmentInputComponent {
    @Input() public value: AttachmentValue | null = null;
    @Input() public isUploading = false;
    @Input() public acceptedMimes = '*/*';
    @Input() public disableInputWhenHasValue = false;
    @Input() public canRemove = true;
    @Input() public attachTooltipKey = 'translate_add_new_attachment';
    @Input() public removeTooltipKey = 'translate_remove';
    @Input() public placeholderKey = 'translate_no_file_selected';
    @Output() public fileSelected = new EventEmitter<File>();
    @Output() public remove = new EventEmitter<void>();

    public readonly inputId = uuid();

    public get hasValue(): boolean {
        return !!this.value;
    }

    public get shouldDisableInput(): boolean {
        return this.disableInputWhenHasValue && this.hasValue;
    }

    public triggerInput(input: HTMLInputElement): void {
        if (this.shouldDisableInput) {
            return;
        }

        input.click();
    }

    public onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }

        this.fileSelected.emit(file);
        input.value = '';
    }

    public onRemove(): void {
        this.remove.emit();
    }
}
